import PropTypes from 'prop-types'

import SectionFinancingTerms from '@adv-mt/mt-section-financing-legal-terms'
import TableFinancingDetails from '@adv-mt/mt-table-financing-details'

const CardAdModalChildren = ({financingInfo}) => {
  return (
    <div className="mt-CardAd-financingInfoModalChildren">
      {Object.keys(financingInfo).length > 0 && (
        <TableFinancingDetails financingData={financingInfo} isLink={false} isModal />
      )}

      <SectionFinancingTerms financingData={financingInfo} titleSize="xs" />
    </div>
  )
}

CardAdModalChildren.displayName = 'CardAdModalChildren'

CardAdModalChildren.propTypes = {
  financingInfo: PropTypes.object
}

export default CardAdModalChildren
